import React from "react";
import "./ProductHero.css";

interface ProductVariant {
  voltage: string;
  power: string;
  lumen: string;
  size: string;
  // Optional: add base and lifeHours per variant if they differ
  base?: string;
  lifeHours?: string;
}

interface Product {
  id: number;
  image: string;
  name: string;
  description: string;
  variants: ProductVariant[];
  // Common attributes (same for all variants)
  cri?: string;
  base?: string;
  lifeHours?: string;
}

interface ProductHeroProps {
  product: Product;
}

const ProductHero: React.FC<ProductHeroProps> = ({ product }) => {
  const showVoltageColumn = product.variants.some(
    (v) => (v.voltage ?? "").trim().length > 0,
  );
  const showPowerColumn = product.variants.some(
    (v) => (v.power ?? "").trim().length > 0,
  );
  const showLumenColumn = product.variants.some(
    (v) => (v.lumen ?? "").trim().length > 0,
  );
  const showSizeColumn = product.variants.some(
    (v) => (v.size ?? "").trim().length > 0,
  );
  const showVariantsTable =
    showVoltageColumn || showPowerColumn || showLumenColumn || showSizeColumn;

  return (
    <section className="product-hero">
      <div className="frame-104">
        {/* Product Image */}
        <div className="frame-106">
          <img
            className="product-image"
            src={product.image}
            alt={product.name}
          />
        </div>

        {/* Product Details */}
        <div className="frame-99">
          {/* Breadcrumb */}
          <div className="frame-121">
            <p className="breadcrumb">Products </p>
            <p className="bradcrumb-product">/ {product.name}</p>
          </div>

          {/* Product Info */}
          <div className="frame-97">
            <h3 className="product-title">{product.name}</h3>
            <p className="product-description">{product.description}</p>
          </div>

          {/* Variants Table */}
          {showVariantsTable && (
            <div
              className="variants-table-container"
              style={{ marginTop: "32px" }}
            >
              <div className="variants-table">
                {/* Table Header */}
                <div className="variants-row header">
                  {showVoltageColumn && (
                    <div className="variants-header-cell">Voltage</div>
                  )}
                  {showPowerColumn && (
                    <div className="variants-header-cell">Power</div>
                  )}
                  {showLumenColumn && (
                    <div className="variants-header-cell">Lumen</div>
                  )}
                  {showSizeColumn && (
                    <div className="variants-header-cell">Size</div>
                  )}
                </div>

                {/* Table Rows - One per variant */}
                {product.variants.map((variant, index) => (
                  <div key={index} className="variants-row">
                    {showVoltageColumn && (
                      <div className="variants-cell">{variant.voltage}</div>
                    )}
                    {showPowerColumn && (
                      <div className="variants-cell">{variant.power}</div>
                    )}
                    {showLumenColumn && (
                      <div className="variants-cell">{variant.lumen}</div>
                    )}
                    {showSizeColumn && (
                      <div className="variants-cell">{variant.size}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductHero;
